export default "__VITE_ASSET__86c218c8__"